import { queryOptions, useQuery } from '@tanstack/react-query'
import { fetchGiftCardOptions } from '@/features/purchase/services/GiftCard/fetchers'

export const giftCardOptionsQueryOptions = queryOptions({
  queryKey: ['Gift Card Options'] as const,
  queryFn: fetchGiftCardOptions,
})

export const useQueryGiftCardChoices = ({ enabled = true }: { enabled?: boolean } = {}) => {
  return useQuery({ ...giftCardOptionsQueryOptions, enabled })
}
